import { useState, useEffect, useCallback } from 'react';
import { moduleService, authService } from '../services';

export const useModules = () => {
  const [modules, setModules] = useState([]);
  const [statuses, setStatuses] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchModules = async () => {
      try {
        const data = await moduleService.getModules();
        setModules(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchModules();
  }, []);

  const checkModuleStatus = useCallback(async (moduleId) => {
    try {
      const status = await moduleService.getModuleStatus(moduleId);
      setStatuses(prev => ({ ...prev, [moduleId]: status }));
      return status;
    } catch (err) {
      return { status: 'offline', available: false };
    }
  }, []);

  const openModule = useCallback(async (module) => {
    if (module.status === 'coming_soon') {
      return;
    }

    try {
      const { token } = await authService.generateModuleToken(module.id);
      const moduleUrl = new URL(module.url);
      moduleUrl.searchParams.set('sso_token', token);
      moduleUrl.searchParams.set('return_url', window.location.href);

      if (module.openInNewTab) {
        window.open(moduleUrl.toString(), '_blank');
      } else {
        window.location.href = moduleUrl.toString();
      }
    } catch (err) {
      console.error('Failed to open module:', err);
    }
  }, []);

  return {
    modules,
    statuses,
    isLoading,
    error,
    checkModuleStatus,
    openModule
  };
};

export default useModules;
